import { LinearProgress } from '@mui/material';
import { memo } from 'react';
import { TestIdsComponents } from '#app/shared/components/TestIdsComponents';

export default memo(function Loading() {
  return <LinearProgress data-testid={TestIdsComponents.LoadingIndicator} />;
});
